import { format } from 'date-fns';
import column from '../../abstract/column';
import form from '../../abstract/form';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

const expiresAtFormat = 'yyyy-MM-dd';
export const roleOptions = {
  broker: {
    label: 'Pośrednik',
    value: 1,
  },
  ao: {
    label: 'Biuro rachunkowe',
    value: 2,
  },
  aoTrusted: {
    label: 'Zaufane biuro rachunkowe',
    value: 3,
  },
  aoInvoicing: {
    label: 'Klient AO - fakturowanie',
    value: 4,
  },
  aoEvidences: {
    label: 'Klient AO - ewidencje',
    value: 5,
  },
  aocFiles: {
    label: 'Klient AO - pliki',
    value: 6,
  },
  aocStaff: {
    label: 'Klient AO - kadry',
    value: 7,
  },
  hub: {
    label: 'Hub',
    value: 8,
  },
  webmaster: {
    label: 'Właściciel strony internetowej',
    value: 9,
  },
  aoSupport: {
    label: 'Posiadacz wsparcia technicznego dla systemu',
    value: 10,
  },
};

export default {
  actions,
  topRightActions: {
    create: {
      label: 'Dodaj role',
      icon: 'icon-plus',
      handle: async ({ $router }) => {
        await $router.push(`/system-roles/add`);
      },
    },
  },
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    created_at: column({
      label: 'Data dodania',
    }),
    editor: column({
      label: 'Edytor',
      component: 'value-editor',
    }),
    subscriptionorder: column({
      label: 'Zamówienie',
    }),
    role: column({
      label: 'Rola',
      format: (item) => {
        return item.role?.title;
      },
      form: form({
        required: true,
      }),
      options: roleOptions,
    }),
    demo: column({
      label: 'Demo',
      format: (item) => {
        if (item.demo) {
          return 'Tak';
        }

        return 'Nie';
      },
    }),
    expires_at: column({
      label: 'Wygasa dnia',
      form: form({
        transform: ({ value }) => new Date(value),
        reverseTransform: ({ value }) => format(value, expiresAtFormat),
      }),
      dateFormat: expiresAtFormat,
    }),
  },
  vars: vars({
    softDelete: {
      title: 'Usunięcie roli',
      text: ({ role }) => `Czy napewno chcesz usunąć rolę?`,
      successText: 'Rola została usunięta.',
    },
    noItemsText: 'Brak ról',
    sidebarLabel: 'Podgląd roli',
    onSuccessSave: async ({ $router }) => await $router.push('/system-roles'),
  }),
};
